import { createServerFn } from "@tanstack/react-start";
import { loadSizeIndex, loadSizeSeed } from "@/lib/size-compare.server";

export const getSizeIndex = createServerFn({ method: "GET" }).handler(
  async () => await loadSizeIndex(),
);

export const getSizeSeed = createServerFn({ method: "GET" })
  .inputValidator((data: { a?: string; b?: string } | undefined) => data ?? {})
  .handler(async ({ data }) => await loadSizeSeed(data.a, data.b));
